import reducer from './reducer'
import type { State } from './reducer'

import * as participantsActions from './actions'
import participantsSagas from './sagas'

export {
  participantsActions,
  participantsSagas
}

export type ParticipantsState = State;

export default reducer
